import { useEffect } from 'react';

import { useTracking } from '@xing-com/crate-communication-tracking';

export const usePeopleDirectoryPageView = (key?: string): void => {
  const { track: trackNwt } = useTracking();
  useEffect(() => {
    trackNwt({
      application: 'wbm',
      type: 'nwt',
      event: 'viewed_screen',
      eventSchema: 'basic',
      channel: 'web',
      sentBy: 'people_directory',
      page: `people_directory/${key}`,
    });
  }, [key, trackNwt]);
};
